export default __webpack_public_path__ + "static/media/High-precision.6edf4e24.png";